import Bil from './bil.svg?react'
import Indbo from './indbo.svg?react'
import Ulykke from './ulykke.svg?react'
import Hus from './hus.svg?react'
import Hund from './hund.svg?react'
import Andre from './andre.svg?react'
import Ingen from './ingen.svg?react'
import type { InsuranceId } from '../types'

const map: Record<InsuranceId, React.FC<React.SVGProps<SVGSVGElement>>> = {
  bil: Bil,
  indbo: Indbo,
  ulykke: Ulykke,
  hus: Hus,
  hund: Hund,
  andre: Andre,
  ingen: Ingen,
}

interface Props {
  name: InsuranceId
  size?: number
  className?: string
}

export function InsuranceIcon({ name, size, className }: Props) {
  const Cmp = map[name]
  return <Cmp width={size} height={size} className={className} aria-hidden="true" />
}
